const dev = {
  goodsDetailURL: '/goods-detail.html', // 商品详情
  goodsListUrl: '/dish-menu.html', // 商品列表页
  valueCardDetailUrl: '/mine-balance-detail-list.html', // 储值详情说明页
  orderRecharge: '/mine-recharge.html', // 充值页面
};

const prod = {
  goodsDetailURL: '/orderall/goodsDetail',
  goodsListUrl: '/takeaway/getWMPageTpl',
  valueCardDetailUrl: '/member/valueCardDetail',
  orderRecharge: '/shop/recharge',
};

export default process.env.NODE_ENV === 'production' ? prod : dev;



// WEBPACK FOOTER //
// ./src/router.js